import { render, staticRenderFns } from "./reserveRecord.vue?vue&type=template&id=64e52240&"
import script from "./reserveRecord.vue?vue&type=script&lang=js&"
export * from "./reserveRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports